import { render } from "./Api.vue?vue&type=template&id=0688a487&ts=true"
import script from "./Api.vue?vue&type=script&lang=ts"
export * from "./Api.vue?vue&type=script&lang=ts"

import "./Api.vue?vue&type=style&index=0&id=0688a487&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__